/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SetBrandTippingConfigurationRequest} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'
import {SetBrandTippingConfigurationResponse} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'


export const setBrandTippingConfiguration = (request: SetBrandTippingConfigurationRequest, options?: CashRequestOptions) => post<SetBrandTippingConfigurationRequest, SetBrandTippingConfigurationResponse>("/2.0/cash/set-brand-tipping-configuration", request, {...options, rejectOnError: true })